import script from "./QuestionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionsView.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionsView.vue?vue&type=style&index=0&id=45c814ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c814ae"]])

export default __exports__